import { ThemePreference } from "../../../shared/utility/designer-theme";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaTabs from "../../ui-kit/kuika-tabs/kuika-tabs";
import "./user-menu-appearance.scss";

interface IThemePreferenceOption {
  preference: ThemePreference;
  label: string;
  icon: string;
  testId: string;
}

/** In picking order; the account menu's Enter on this row walks the same order. */
const THEME_PREFERENCE_OPTIONS: readonly IThemePreferenceOption[] = [
  { preference: "system", label: "System", icon: "device-desktop", testId: "userMenuAppearanceSystem" },
  { preference: "light", label: "Light", icon: "sun", testId: "userMenuAppearanceLight" },
  { preference: "dark", label: "Dark", icon: "moon", testId: "userMenuAppearanceDark" }
];

/** The preference after `preference`, wrapping from the last back to the first. */
export const nextThemePreference = (preference: ThemePreference): ThemePreference => {
  const index: number = THEME_PREFERENCE_OPTIONS.findIndex(
    (option: IThemePreferenceOption): boolean => option.preference === preference
  );
  return THEME_PREFERENCE_OPTIONS[(index + 1) % THEME_PREFERENCE_OPTIONS.length].preference;
};

export interface IUserMenuAppearanceProps {
  value: ThemePreference;
  onChange: (preference: ThemePreference) => void;
}

/**
 * The account menu's theme row: a small "Theme" caption over the System / Light / Dark control,
 * every option showing its icon and name. The caption is the group's accessible name.
 */
const UserMenuAppearance = ({ value, onChange }: IUserMenuAppearanceProps): JSX.Element => {
  const handleChange = (next: string): void => {
    const option: IThemePreferenceOption | undefined = THEME_PREFERENCE_OPTIONS.find(
      (candidate: IThemePreferenceOption): boolean => candidate.preference === next
    );
    if (option === undefined || option.preference === value) {
      return;
    }
    onChange(option.preference);
  };

  return (
    <div className="kuika-user-menu-appearance">
      <div className="kuika-user-menu-appearance__title">Theme</div>
      <KuikaTabs
        value={value}
        onChange={handleChange}
        ariaLabel="Theme"
        options={THEME_PREFERENCE_OPTIONS.map((option: IThemePreferenceOption) => ({
          value: option.preference,
          label: (
            <div className="kuika-user-menu-appearance__option" data-testid={option.testId}>
              <KuikaSvg name={option.icon} color="currentColor" />
              {option.label}
            </div>
          )
        }))}
      />
    </div>
  );
};

export default UserMenuAppearance;
